import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CedenteGestorCadastro } from '../models/cedentegestor-cadastro';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private cadastro = new BehaviorSubject(null);
  currentCadastro = this.cadastro.asObservable();

  constructor() { }

  changeCedenteGestorCadastro(cadastro: CedenteGestorCadastro) {
    this.cadastro.next(cadastro);
  }

}
